import { GameObject } from '../base/GameObject';
import Phaser from 'phaser';

export abstract class Pet extends GameObject {
  protected level: number;
  protected range: number;
  protected damage: number;
  protected attackSpeed: number;
  protected lastAttackTime: number = 0;
  protected orbitRadius: number = 130;
  protected orbitSpeed: number = 0.7; // rad/s
  protected orbitAngle: number = 0;
  protected target: GameObject | null = null;
  protected earth: GameObject;

  constructor(scene: Phaser.Scene, earth: GameObject, angle: number) {
    super(scene, earth.x, earth.y);
    this.earth = earth;
    this.orbitAngle = angle;
    this.range = 110;
    this.damage = 10;
    this.attackSpeed = 1;
    this.level = 1;
  }

  levelUp(level: number): void {
    this.level = level;
    // Nâng cấp chỉ số nếu có
    this.damage += (level - 1) * 4;
    this.range += (level - 1) * 8;
    this.attackSpeed += (level - 1) * 0.3;
  }
  override update(time: number, delta: number): void {
    // Di chuyển quanh Earth
    this.orbitAngle += this.orbitSpeed * delta / 1000;
    this.x = this.earth.x + Math.cos(this.orbitAngle) * this.orbitRadius;
    this.y = this.earth.y + Math.sin(this.orbitAngle) * this.orbitRadius;
    // Tìm target
    if (!this.target || this.target.getHealth() <= 0 || Phaser.Math.Distance.Between(this.x, this.y, this.target.x, this.target.y) > this.range) {
      this.findTarget();
    }
    // Attack
    if (this.target && time - this.lastAttackTime > 1000 / this.attackSpeed) {
      this.attack();
      this.lastAttackTime = time;
    }
  }

  protected findTarget(): void {
    if (!this.scene || !this.scene.children) return;
    var _this = this;
    const monsters = this.scene.children.list.filter(child =>
      child instanceof GameObject &&
      (child as any).getHealth && (child as any).getHealth() > 0 &&
      Phaser.Math.Distance.Between(_this.x, _this.y, child.x, child.y) <= _this.range
    ) as GameObject[];
    if (monsters.length === 0) { this.target = null; return; }
    let nearest = monsters[0] as GameObject;
    let minDist = Phaser.Math.Distance.Between(_this.x, _this.y, nearest.x, nearest.y);
    for (const m of monsters) {
      const d = Phaser.Math.Distance.Between(_this.x, _this.y, m.x, m.y);
      if (d < minDist) { nearest = m as GameObject; minDist = d; }
    }
    this.target = nearest as GameObject;
  }

  upgrade(): void {
    this.level++;
    this.levelUp(this.level);
  }

  getLevel(): number {
    return this.level;
  }

  abstract attack(): void;
} 